import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Flex,
  Checkbox,
  VStack,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from "@chakra-ui/react";
import { FiSearch, FiChevronDown } from "react-icons/fi";
import {
  BRANDS_LIST,
  getAxiosConfig,
  TYPES_LIST,
} from "../../../utils/helpers";
import axios from "axios";

const FilterBar = ({
  filter,
  setFilter,
  isFixed = true,
  subFilter,
  children,
  isSidebarOpen = false,
  clearSubFilter = () => {},
  setFilterLoading = () => {},
  materialPrice = {},
  setMaterialPrice = {},
  setCurrPage = {},
  refetchFilter,
}) => {
  // // console.log({filter,subFilter})
  const hasSubFilters = useMemo(() => {
    return Object.keys(subFilter).some((key) => {
      if (Array.isArray(subFilter[key])) {
        return subFilter[key].length > 0;
      }
      return subFilter[key] != null && subFilter[key] !== "";
    });
  }, [subFilter]);
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [isAreasOpen, setIsAreasOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(false);
  const [tempMinPrice, setTempMinPrice] = useState("");
  const [tempMaxPrice, setTempMaxPrice] = useState("");
  const [validationError, setValidationError] = useState("");
  const [searchInput, setSearchInput] = useState(filter.search || "");
  const [areas, setAreas] = useState([]);
  const allFilterOptions = BRANDS_LIST.reduce((acc, brand) => {
    const type = brand.type || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(brand);
    return acc;
  }, {});
  const [totalFilters, setTotalFilters] = useState(allFilterOptions);
  // console.log({ totalFilters, filter });

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleBrandToggle = (brandId) => {
    const currentBrands = filter.brands || [];
    const updatedBrands = currentBrands.includes(brandId)
      ? currentBrands.filter((b) => b !== brandId)
      : [...currentBrands, brandId];
    setFilter({ ...filter, brands: updatedBrands });
  };

  const handleTypeToggle = (type, brandIds) => {
    const currentBrands = filter.brands || [];
    const allSelected = brandIds.every((id) => currentBrands.includes(id));

    let newBrands;
    if (allSelected) {
      // Deselect all brands of this type
      newBrands = currentBrands.filter((id) => !brandIds.includes(id));
    } else {
      // Select all brands of this type
      newBrands = [...new Set([...currentBrands, ...brandIds])];
    }

    setFilter({ ...filter, brands: newBrands });
  };

  const handleAreaToggle = (area) => {
    const currentAreas = filter.zone || [];
    const updatedAreas = currentAreas.includes(area)
      ? currentAreas.filter((a) => a !== area)
      : [...currentAreas, area];
    setFilter({ ...filter, zone: updatedAreas });
  };

  const selectedBrandsCount = (filter.brands || []).length;
  const selectedAreasCount = (filter.zone || []).length;
  const hasActivePriceFilter =
    (materialPrice?.minPrice !== null &&
      materialPrice?.minPrice !== undefined &&
      materialPrice?.minPrice !== "") ||
    (materialPrice?.maxPrice !== null &&
      materialPrice?.maxPrice !== undefined &&
      materialPrice?.maxPrice !== "");

  const hasActiveFilters =
    selectedBrandsCount > 0 ||
    selectedAreasCount > 0 ||
    (filter.search || "").length > 0 ||
    hasActivePriceFilter;

  const handleClearAll = () => {
    // setSearchInput("");
    setFilter({
      search: "",
      brands: [],
      types: [],
      zone: [],
    });
    if (typeof setMaterialPrice === "function") {
      setMaterialPrice({
        minPrice: null,
        maxPrice: null,
      });
    }
    setTempMinPrice("");
    setTempMaxPrice("");
    setValidationError("");
  };

  const handlePriceDone = () => {
    const minVal =
      tempMinPrice === "" || tempMinPrice === null || tempMinPrice === undefined
        ? null
        : parseFloat(tempMinPrice);
    const maxVal =
      tempMaxPrice === "" || tempMaxPrice === null || tempMaxPrice === undefined
        ? null
        : parseFloat(tempMaxPrice);

    if (minVal !== null && (isNaN(minVal) || minVal < 0)) {
      setValidationError("Min price must be >= 0");
      return;
    }
    if (maxVal !== null && (isNaN(maxVal) || maxVal < 0)) {
      setValidationError("Max price must be >= 0");
      return;
    }
    if (minVal !== null && maxVal !== null && minVal > maxVal) {
      setValidationError("Min price must be <= Max price");
      return;
    }

    setValidationError("");
    if (typeof setMaterialPrice === "function") {
      setMaterialPrice({
        minPrice: minVal,
        maxPrice: maxVal,
      });
      setCurrPage(1);
    }
    setIsPriceOpen(false);
  };

  const fetchfilters = async () => {
    try {
      setFilterLoading(true);
      let updatedSubFilter = {};
      Object.keys(subFilter).forEach((key) => {
        if (
          subFilter[key] != null &&
          subFilter[key] !== "" &&
          !(Array.isArray(subFilter[key]) && subFilter[key].length === 0)
        ) {
          updatedSubFilter[key] = subFilter[key];
        }
      });
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}` +
          "/api/material/get-all-mainfilter",
        getAxiosConfig({
          filter: JSON.stringify({
            ...updatedSubFilter,
            areas: filter?.zone || [],
            brand: filter?.brands || [],
          }),
        }),
      );
      // console.log("Fetched filters:", data);
      let filterObj = {};
      data.data?.collections?.forEach((collection) => {
        filterObj[collection?.type] = collection?.brands?.map((v) => ({
          _id: v,
        }));
      });
      setTotalFilters(filterObj);
      setAreas(data?.data?.areas?.[0]?.areas);
    } catch (error) {
      // console.log(error);
    } finally {
      setFilterLoading(false);
    }
  };

  // Debounce effect for search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFilter({ ...filter, search: searchInput });
    }, 500); // 500ms debounce delay

    return () => clearTimeout(timeoutId);
  }, [searchInput]);
  useEffect(() => {
    console.log("FILTERS IN FILTERS", {
      subFilter,
      zone: filter.zone,
      brands: filter.brands,
    });
    fetchfilters();
  }, [
    subFilter,
    JSON.stringify(filter.zone),
    JSON.stringify(filter.brands),
    refetchFilter,
  ]);

  useEffect(() => {
    if (filter.search != searchInput) {
      setSearchInput(filter.search || "");
    }
  }, [filter.search]);

  useEffect(() => {
    setTempMinPrice(materialPrice?.minPrice ?? "");
    setTempMaxPrice(materialPrice?.maxPrice ?? "");
    setValidationError("");
  }, [materialPrice]);
  //   useEffect(() => {
  // fetchfilters();
  //   },[])

  return (
    <Box
      position={isFixed ? "fixed" : "relative"}
      bottom={isFixed ? "20px" : "auto"}
      left={isSidebarOpen ? "50%" : "50%"}
      transform={isSidebarOpen ? "translateX(-30%)" : "translateX(-50%)"}
      bg="rgba(255, 255, 255, 0.8)"
      backdropFilter="blur(10px)"
      border="1px solid"
      borderColor="rgba(20, 184, 166, 0.2)"
      borderRadius="xl"
      py={isFixed ? 4 : 0}
      px={isFixed ? 6 : 0}
      zIndex={90}
      boxShadow="0 8px 32px rgba(20, 184, 166, 0.15)"
      w="fit-content"
      maxW="90vw"
    >
      <Flex gap={4} align="center" justify="center" maxW="1200px" mx="auto">
        {/* Search Bar */}
        <InputGroup flex="1" maxW="500px" minW="150px">
          <InputLeftElement pointerEvents="none">
            <FiSearch color="gray" />
          </InputLeftElement>
          <Input
            placeholder="Search products..."
            value={searchInput}
            onChange={handleSearchChange}
            borderRadius="lg"
            bg="gray.50"
            _focus={{ bg: "white", borderColor: "teal.500" }}
          />
        </InputGroup>

        {/* Brand Filter */}
        <Popover
          isOpen={isBrandOpen}
          onClose={() => setIsBrandOpen(false)}
          placement="top"
          closeOnBlur={true}
        >
          <PopoverTrigger>
            <Button
              rightIcon={<FiChevronDown />}
              onClick={() => setIsBrandOpen(!isBrandOpen)}
              variant="outline"
              borderRadius="lg"
              bg={selectedBrandsCount > 0 ? "teal.50" : "white"}
              borderColor={selectedBrandsCount > 0 ? "teal.500" : "gray.300"}
              color={selectedBrandsCount > 0 ? "teal.600" : "gray.700"}
              _hover={{ bg: selectedBrandsCount > 0 ? "teal.100" : "gray.50" }}
            >
              Filter by brand{" "}
              {selectedBrandsCount > 0 && `(${selectedBrandsCount})`}
            </Button>
          </PopoverTrigger>
          <PopoverContent maxW="300px">
            <PopoverArrow />
            <PopoverBody>
              <Text fontWeight="bold" mb={3} fontSize="sm" color="gray.700">
                Filter by Brand & Type
              </Text>
              <VStack align="stretch" spacing={3} maxH="400px" overflowY="auto">
                {Object.entries(totalFilters).map(([type, brands]) => {
                  const allBrandIds = brands.map((b) => b._id);
                  const selectedInType = allBrandIds.filter((id) =>
                    (filter.brands || []).includes(id),
                  );
                  const isAllSelected =
                    selectedInType.length === allBrandIds.length;
                  const isIndeterminate =
                    selectedInType.length > 0 && !isAllSelected;

                  return (
                    <Box
                      key={type}
                      borderWidth="1px"
                      borderRadius="md"
                      p={2}
                      bg="gray.50"
                    >
                      <Checkbox
                        isChecked={isAllSelected}
                        isIndeterminate={isIndeterminate}
                        onChange={() => handleTypeToggle(type, allBrandIds)}
                        colorScheme="teal"
                        fontWeight="semibold"
                        mb={2}
                      >
                        {type}
                      </Checkbox>
                      <VStack align="stretch" spacing={1} pl={6}>
                        {brands.map((brand) => (
                          <Checkbox
                            key={brand._id}
                            isChecked={(filter.brands || []).includes(
                              brand._id,
                            )}
                            onChange={() => handleBrandToggle(brand._id)}
                            colorScheme="teal"
                            size="sm"
                          >
                            {brand._id}
                          </Checkbox>
                        ))}
                      </VStack>
                    </Box>
                  );
                })}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>

        {/* Areas Filter */}
        {areas && Array.isArray(areas) && areas.length > 0 && (
          <Popover
            isOpen={isAreasOpen}
            onClose={() => setIsAreasOpen(false)}
            placement="top"
            closeOnBlur={true}
          >
            <PopoverTrigger>
              <Button
                rightIcon={<FiChevronDown />}
                onClick={() => setIsAreasOpen(!isAreasOpen)}
                variant="outline"
                borderRadius="lg"
                bg={selectedAreasCount > 0 ? "teal.50" : "white"}
                borderColor={selectedAreasCount > 0 ? "teal.500" : "gray.300"}
                color={selectedAreasCount > 0 ? "teal.600" : "gray.700"}
                _hover={{ bg: selectedAreasCount > 0 ? "teal.100" : "gray.50" }}
              >
                Filter by area{" "}
                {selectedAreasCount > 0 && `(${selectedAreasCount})`}
              </Button>
            </PopoverTrigger>
            <PopoverContent maxW="300px">
              <PopoverArrow />
              <PopoverBody>
                <Text fontWeight="bold" mb={3} fontSize="sm" color="gray.700">
                  Filter by Area
                </Text>
                <VStack
                  align="stretch"
                  spacing={2}
                  maxH="300px"
                  overflowY="auto"
                >
                  {areas.map((area) => (
                    <Checkbox
                      key={area}
                      isChecked={(filter.zone || []).includes(area)}
                      onChange={() => handleAreaToggle(area)}
                      colorScheme="teal"
                    >
                      {area}
                    </Checkbox>
                  ))}
                </VStack>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        )}

        {/* Price Filter */}
        <Popover
          isOpen={isPriceOpen}
          onClose={() => setIsPriceOpen(false)}
          placement="top"
          closeOnBlur={true}
        >
          <PopoverTrigger>
            <Button
              rightIcon={<FiChevronDown />}
              onClick={() => setIsPriceOpen(!isPriceOpen)}
              variant="outline"
              borderRadius="lg"
              bg={hasActivePriceFilter ? "teal.50" : "white"}
              borderColor={hasActivePriceFilter ? "teal.500" : "gray.300"}
              color={hasActivePriceFilter ? "teal.600" : "gray.700"}
              _hover={{ bg: hasActivePriceFilter ? "teal.100" : "gray.50" }}
            >
              Filter by price
              {/* {hasActivePriceFilter &&
                ` (${materialPrice.minPrice !== null && materialPrice.minPrice !== undefined && materialPrice.minPrice !== "" ? materialPrice.minPrice : 0} - ${materialPrice.maxPrice !== null && materialPrice.maxPrice !== undefined && materialPrice.maxPrice !== "" ? materialPrice.maxPrice : "∞"})`} */}
            </Button>
          </PopoverTrigger>
          <PopoverContent maxW="300px">
            <PopoverArrow />
            <PopoverBody>
              <Text fontWeight="bold" mb={3} fontSize="sm" color="gray.700">
                Filter by Price
              </Text>
              <VStack align="stretch" spacing={3}>
                <Flex gap={2}>
                  <Box>
                    <Text fontSize="xs" color="gray.500" mb={1}>
                      Min Price
                    </Text>
                    <Input
                      // type="number"
                      placeholder="0"
                      value={tempMinPrice}
                      onChange={(e) => {
                        if (
                          e.target.value === "" ||
                          e.target.value == "0" ||
                          !isNaN(e.target.value)
                        )
                          setTempMinPrice(e.target.value);
                      }}
                      size="sm"
                      borderRadius="md"
                    />
                  </Box>
                  <Box>
                    <Text fontSize="xs" color="gray.500" mb={1}>
                      Max Price
                    </Text>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={tempMaxPrice}
                      onChange={(e) => {
                        if (
                          e.target.value === "" ||
                          e.target.value == "0" ||
                          !isNaN(e.target.value)
                        )
                          setTempMaxPrice(e.target.value);
                      }}
                      size="sm"
                      borderRadius="md"
                    />
                  </Box>
                </Flex>
                {validationError && (
                  <Text color="red.500" fontSize="xs">
                    {validationError}
                  </Text>
                )}
                <Button
                  colorScheme="teal"
                  size="sm"
                  onClick={handlePriceDone}
                  borderRadius="md"
                  w="full"
                >
                  Done
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>

        {children}

        {/* Clear All Button */}
        {(hasActiveFilters || hasSubFilters) && (
          <Button
            onClick={() => {
              handleClearAll();
              clearSubFilter();
            }}
            disabled={!(hasActiveFilters || hasSubFilters)}
            variant="ghost"
            colorScheme="red"
            size="md"
            borderRadius="lg"
            _hover={{ bg: "red.50" }}
          >
            Clear All
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default FilterBar;
